import { VatField } from '../elements/VatField';
import { LatamVatValidator } from '../companyInfo.validators';
import {
    CompanyAddressDetailsContainer,
    CompanyHouseNoContainer,
    CompanyNameContainer,
    CompanyNeighborhoodContainer,
    CompanyPhoneContainer,
    CompanyStateContainer,
    CompanyStreetContainer,
    CompanyZipCodeContainer,
} from '../elements/CompanyInfoElementContainers';
import { AlreadyRegistered } from '../elements/AlreadyRegistered';
import { CompanyInfoNextButton } from '../elements/CompanyInfoNextButton';
import { TaxTypeRadioButton } from '../elements/TaxTypeRadioButton';
import { LatamCitySelect } from '../elements/LatamCitySelect';
import { DummyCountrySelectLatam } from '../elements/DummyCountrySelectLatam';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from '@reduxjs/toolkit';
import { companyInfoCountryCodeSelector, setBrazilCities, setCompanyInfoField } from '../companyInfoSlice';
import { Region, regionSelector, setRegion } from '../../region/regionSlice';
import { useAppSelector } from '../../../configuration/setup/hooks';
import { isAppInMaintenanceMode } from '../../../configuration/tmpSlice';
import { LanguageSelect } from '../elements/LanguageSelect';

const loadBrazilCityList = (dispatch: Dispatch) => {
    import('../../../brasil-city-list.json').then(({ default: brazilCities }) => {
        dispatch(setBrazilCities(brazilCities));
    });
};

const setBrCountryCode = (dispatch: Dispatch) => {
    dispatch(setCompanyInfoField({ fieldName: 'countryCode', value: 'BR' }));
};

export const LatamCompanyInfo = () => {
    const dispatch = useDispatch();
    const region = useAppSelector(regionSelector);
    const countryCode = useAppSelector(companyInfoCountryCodeSelector);
    const disabled = useAppSelector(isAppInMaintenanceMode);
    useEffect(() => {
        loadBrazilCityList(dispatch);
        if (region !== Region.latinamerica || countryCode !== 'BR') {
            dispatch(setRegion(Region.latinamerica));
            setBrCountryCode(dispatch);
        }
    }, [dispatch, region, countryCode]);

    return (
        <form className={'CompanyDataContainer'}>
            <div className={'row'}>
                <div>
                    <CompanyNameContainer
                        width={'margin-bottom-10'}
                        error={'registration.error.companyName'}
                        required
                    />
                </div>
                <div>
                    <TaxTypeRadioButton />
                    <VatField
                        validator={LatamVatValidator}
                        vatLabel={'registration.companyData.cnpjcpf'}
                        showPopoverIcon={false}
                        className={'margin-top-5 margin-bottom-5'}
                        disabled={disabled}
                        requireTaxEntitySelection
                        required
                    />
                </div>
                <div>
                    <CompanyZipCodeContainer width={'col-sm-8 margin-bottom-5'} required />
                    <CompanyStreetContainer
                        width={'col-sm-8 margin-top-5 margin-bottom-5'}
                        error={'registration.error.street'}
                        required
                    />
                </div>
                <div>
                    <CompanyHouseNoContainer
                        width={'col-sm-4 margin-top-5 margin-bottom-5'}
                        error={'registration.error.houseNo'}
                        required
                    />
                    <CompanyAddressDetailsContainer width={'col-sm-4 margin-top-5 margin-bottom-5'} required={false} />
                    <CompanyNeighborhoodContainer width={'col-sm-4 margin-top-5 margin-bottom-5'} required />
                </div>
            </div>
            <div className={'row margin-top-5 margin-bottom-5'}>
                <LatamCitySelect width={'col-sm-4'} required />
                <CompanyStateContainer width={'col-sm-2'} />
                <CompanyPhoneContainer width={'col-sm-6'} required />
            </div>
            <div className={'row'}>
                <DummyCountrySelectLatam disabled={disabled} />
                <LanguageSelect tenant={'rio-brazil.prod'} required />
            </div>
            <hr />
            <div className={'margin-top-20-sm'}>
                <div className={'display-flex justify-content-between flex-wrap'}>
                    <AlreadyRegistered />
                    <CompanyInfoNextButton />
                </div>
            </div>
        </form>
    );
};
